import { jsx } from 'react/jsx-runtime';

const SvgMiscSteps1 = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "m3 10.78 2-.5V17h2V7.72l-4 1v2.06ZM21 5h-9v2h9V5ZM21 11h-9v2h9v-2ZM21 17h-9v2h9v-2Z" }) }));

export { SvgMiscSteps1 as default };
//# sourceMappingURL=MiscSteps1.es.js.map
